export const BreakPoints = {
  screenXs: 420,
  screenSm: 760,
  screenMd: 1000,
};
